export const WORKFLOW_PROGRESS = 'WORKFLOW_PROGRESS';
